import { Tag } from "@chakra-ui/react";
import React from "react";

import { PRODUCT_STATUS_CONFIG, ProductStatus } from "./productStatusConfig";

export interface ProductStatusTagProperties {
  status: ProductStatus;
}

export const ProductStatusTag = ({ status }: ProductStatusTagProperties): React.ReactElement => {
  const { backgroundColor, color, text } = PRODUCT_STATUS_CONFIG[status];

  return (
    <Tag backgroundColor={backgroundColor} color={color}>
      {text}
    </Tag>
  );
};
